import { Routes } from '@angular/router';
import { CreateOrderComponent, OrderDetailsComponent, OrdersComponent } from '@dss-libs/portal/feature/contract-order';
import { UserRole } from '@dss-libs/shared/type/common-types';

const titlePrefix = 'JunoSign | Portal';

export const contractOrderRoutes: Routes = [
  {
    path: '',
    redirectTo: 'orders',
    pathMatch: 'full',
  },
  {
    path: 'orders',
    component: OrdersComponent,
    title: `${titlePrefix} - Orders List`,
  },
  {
    path: 'orders/create-order',
    component: CreateOrderComponent,
    title: `${titlePrefix} - Create Order`,
    data: {
      authorizedRole: UserRole.User,
    },
  },
  {
    path: 'orders/:orderId',
    component: OrderDetailsComponent,
    title: `${titlePrefix} - Order Details`,
  },
];
